import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { ISubscription } from '../../types/subscription'

export interface ISubscriptionsState extends IAjaxBaseState<ISubscription[]> {
}

const createInitialSubscriptionsState = (): ISubscriptionsState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialSubscriptionsState
}
